export enum SpriteAlignment {
    Center = 0,
    Start = 1,
    End = 2,
}

export default SpriteAlignment;
